import React from 'react';

import Button from 'react-bootstrap/lib/Button';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import toolkitIcon from './freelancer-toolkit-cluster-logo-1.png';
import bgPattern from './section-background.svg';

import styles from './Toolkit.module.scss';

const Toolkit = () => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${bgPattern}), linear-gradient(to left top, #322954, #363c6e)`,
        backgroundPosition: `50% 17vh, 0 0`,
        backgroundRepeat: `no-repeat, no-repeat !important`,
      }}
    >
      <div className="hidden-sm hidden-md hidden-lg hidden-xl">
        <a
          href="https://www.twine.net/toolkits/freelancer"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className={styles.image}
            data-src={toolkitIcon}
            alt="Freelancer Toolkit"
            src={toolkitIcon}
          />
        </a>
        <a
          href="https://www.twine.net/toolkits/freelancer"
          target="_blank"
          rel="noreferrer"
        >
          <h3 className={styles.header}>
            <strong>Freelancer Toolkit</strong>
          </h3>
        </a>
        <a
          href="https://www.twine.net/toolkits/freelancer"
          target="_blank"
          rel="noreferrer"
        >
          <p className={styles.copy}>
            An essential collection of essential tools and services for
            freelancers starting up
          </p>
        </a>
        <div className={styles.button}>
          <Button
            bsStyle="success"
            bsSize="lg"
            className={styles.moreInfoButton}
            href="https://www.twine.net/toolkits/freelancer"
            target="_blank"
          >
            Learn more <SvgIcon icon="chevron-right" size="14" />
          </Button>
        </div>
      </div>
      <div className="hidden-xs">
        <div>
          <a
            href="https://www.twine.net/toolkits/freelancer"
            target="_blank"
            rel="noreferrer"
          >
            <div className={styles.headerContainer}>
              <div className={styles.imageContainer}>
                <img
                  className={styles.image}
                  data-src={toolkitIcon}
                  alt="Freelancer Toolkit"
                  src={toolkitIcon}
                />
              </div>
              <div className={styles.titleContainer}>
                <h3 className={styles.header}>
                  <strong>Freelancer Toolkit</strong>
                </h3>
              </div>
            </div>
            <p className={styles.copy}>
              An essential collection of tools and services for freelancers
              starting up
            </p>
          </a>
        </div>
        <div className={styles.button}>
          <Button
            bsStyle="success"
            bsSize="lg"
            className={styles.moreInfoButton}
            href="https://www.twine.net/toolkits/freelancer"
            target="_blank"
          >
            Learn more <SvgIcon icon="chevron-right" size="14" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Toolkit;
